import 'css-chunksrc/client/scenes/accountCreationConfirmation/form/wizardForm/styles.scss';export default {
  "wizardForm": "_wizardForm_rlkh6_1",
  "title": "_title_rlkh6_5",
  "navigation": "_navigation_rlkh6_12",
  "nextButton": "_nextButton_rlkh6_21",
  "previousButton": "_previousButton_rlkh6_45"
};